const DEPARTMENT_ALIASES = {
  aiml: "AI/ML",
  aimlengineering: "AI/ML",
};

export const normalizeDepartment = (value) => {
  const label = String(value || "").trim().replace(/\s+/g, " ");
  if (!label) return "Unassigned";

  const key = label.toLowerCase().replace(/[^a-z0-9]/g, "");
  return DEPARTMENT_ALIASES[key] || label;
};
